var uk = {
	"neptune.Button.loadingAriaLabel": "завантаження",
	"neptune.Chips.ariaLabel": "Очистити {choice}",
	"neptune.ClearButton.ariaLabel": "Очистити",
	"neptune.CloseButton.ariaLabel": "Закрити",
	"neptune.DateInput.day.label": "День",
	"neptune.DateInput.day.placeholder": "ДД",
	"neptune.DateInput.month.label": "Місяць",
	"neptune.DateInput.year.label": "Рік",
	"neptune.DateInput.year.placeholder": "РРРР",
	"neptune.DateLookup.day": "дня",
	"neptune.DateLookup.goTo20YearView": "Go to 20 year view",
	"neptune.DateLookup.month": "місяць",
	"neptune.DateLookup.next": "уперед",
	"neptune.DateLookup.previous": "назад",
	"neptune.DateLookup.selected": "вибрано",
	"neptune.DateLookup.twentyYears": "20 років",
	"neptune.DateLookup.year": "рік",
	"neptune.FlowNavigation.back": "back to previous step",
	"neptune.Info.ariaLabel": "Більше відомостей",
	"neptune.Link.opensInNewTab": "(opens in new tab)",
	"neptune.MoneyInput.Select.placeholder": "Виберіть варіант…",
	"neptune.Select.searchPlaceholder": "Пошук…",
	"neptune.SelectInput.noResultsFound": "Нічого не знайдено",
	"neptune.Summary.statusDone": "Виконано",
	"neptune.Summary.statusNotDone": "Не виконано",
	"neptune.Summary.statusPending": "Виконується",
	"neptune.Upload.csButtonText": "Завантажити інший файл?",
	"neptune.Upload.csFailureText": "Не завантажено. Повторіть спробу.",
	"neptune.Upload.csSuccessText": "Завантаження завершено!",
	"neptune.Upload.csTooLargeMessage": "Завантажте файл завбільшки до 5 МБ",
	"neptune.Upload.csWrongTypeMessage": "Тип файлу не підтримується. Спробуйте завантажити інший файл.",
	"neptune.Upload.psButtonText": "Скасувати",
	"neptune.Upload.psProcessingText": "Завантаження…",
	"neptune.Upload.usButtonText": "Або виберіть файл",
	"neptune.Upload.usDropMessage": "Перетягніть файл, щоб почати завантаження",
	"neptune.Upload.usPlaceholder": "Перетягніть файл завбільшки до 5 МБ",
	"neptune.UploadButton.allFileTypes": "Усі типи файлів",
	"neptune.UploadButton.dropFiles": "Перетягніть файл, щоб почати завантаження",
	"neptune.UploadButton.instructions": "{fileTypes}, до {size} МБ",
	"neptune.UploadButton.uploadFile": "Завантажити файл",
	"neptune.UploadButton.uploadFiles": "Завантажити файли",
	"neptune.UploadInput.deleteModalBody": "Якщо вилучити файл, його буде видалено з нашої системи.",
	"neptune.UploadInput.deleteModalCancelButtonText": "Скасувати",
	"neptune.UploadInput.deleteModalConfirmButtonText": "Вилучити",
	"neptune.UploadInput.deleteModalTitle": "Справді вилучити цей файл?",
	"neptune.UploadInput.fileIsTooLarge": "Файл завеликий",
	"neptune.UploadInput.fileTypeNotSupported": "Тип файлу не підтримується",
	"neptune.UploadInput.maximumFilesAlreadyUploaded": "На жаль, це завантаження не вдале. Ми можемо завантажити лише {maxFilesAllowed} файлів за один раз.",
	"neptune.UploadItem.deleting": "Видалення…",
	"neptune.UploadItem.removeFile": "Вилучити файл {filename}",
	"neptune.UploadItem.uploaded": "Завантажено",
	"neptune.UploadItem.uploadedFile": "Завантажено файл",
	"neptune.UploadItem.uploading": "Завантаження…",
	"neptune.UploadItem.uploadingFailed": "Не вдалося завантажити"
};

export { uk as default };
//# sourceMappingURL=uk.json.mjs.map
